export function coffeeSvg(): string {
  return `<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <path fill="none" stroke="currentColor" stroke-width="1.35" stroke-linecap="round" stroke-linejoin="round"
      d="M5 9h11v6.2A3.8 3.8 0 0 1 12.2 19H8.8A3.8 3.8 0 0 1 5 15.2V9z"/>
    <path fill="none" stroke="currentColor" stroke-width="1.35" stroke-linecap="round"
      d="M16 10.2h2.2a2.3 2.3 0 0 1 0 4.6H16"/>
    <path fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"
      d="M8.2 5.2c.15 1.1-.35 1.6-.35 2.4M11.2 5c.2 1.15-.3 1.7-.3 2.55M14.1 5.2c.15 1.05-.3 1.55-.3 2.35"/>
  </svg>`;
}
